export const ActionButtonsBindings = parent => {
    parent.copyLimitProfile = parent.copyLimitProfile.bind(parent);
    parent.displayLimitProfile = parent.displayLimitProfile.bind(parent);
    parent.editLimitProfile = parent.editLimitProfile.bind(parent);
    parent.deleteLimitProfile = parent.deleteLimitProfile.bind(parent);
};
